import { IndexableDocument } from '@backstage/plugin-search-common';
import { EpSdkBrokerTypes } from '@solace-labs/ep-sdk';
import { IEpDevPApplicationDomain } from '../api';
import { TEpDevPAttributeList } from './EpDevPAttributesServiceTypes';
import { TEpDevPTag } from './EpDevPCommon';
import { IEpDevPEntityIdObject, TEpDevPEntityId } from './EpDevPEntityIdsServiceTypes';
import { EpDevPDocumentTypes } from '../constants';

export enum EEpDevPAssetStateFilter {
  Released = "released",
  Any = "any"
}
export enum EEpDevPObjectAttributeNames {
  _X_EP_DEVP_DOMAIN_OWNING_ID_ = "_X_EP_DEVP_DOMAIN_OWNING_ID_",
  _X_EP_DEVP_DOMAIN_SHARING_LIST_ = "_X_EP_DEVP_DOMAIN_SHARING_LIST_",
  _X_EP_DEVP_PUBLISH_DESTINATION_SYSTEM_ID_LIST_ = "_X_EP_DEVP_PUBLISH_DESTINATION_SYSTEM_ID_LIST_",
  _X_EP_DEVP_SEARCH_WORD_LIST_ = "_X_EP_DEVP_SEARCH_WORD_LIST_",
  // dev portal does not know the owner
  // _X_EP_DEVP_OWNER_ID_ = "_X_EP_DEVP_OWNER_ID_",
}

export enum EEpDevPDomainSharingAccessType {
  READONLY = "readonly",
  FULL_ACCESS = "full-access",
}

export type TEpDevPDomainSharing = IEpDevPEntityIdObject & {
  accessType: EEpDevPDomainSharingAccessType;
}
export type TEpDevPDomainSharingList = Array<TEpDevPDomainSharing>;
export type TEpDevPDomainInfo = {
  owningDomainEntityId: TEpDevPEntityId;
  domainSharingList: TEpDevPDomainSharingList;
}

/**
 * Lifecycle info for LCM assets.
 */
export interface IEpDevPAssetLifecycleInfo {
  version: string;
  versionId: string;
  lifecycleState: string;
}
/**
 * Broker type info.
 */
export interface IEpDevPAssetBrokerTypeInfo {
  brokerType: EpSdkBrokerTypes | undefined;
}
export type TEpDevPLocationInfo = {
  epDevPLocation: string;
  epConsoleLocation: string;
}
/**
 * Base for all assets.
 */
export interface IEpDevPAsset extends IEpDevPEntityIdObject {
  organizationEntityId: TEpDevPEntityId;
  epDevPDomainInfo: TEpDevPDomainInfo;
  epDevPDocumentType: EpDevPDocumentTypes;
  epDevPLocationInfo: TEpDevPLocationInfo;
  kind: string;
  tags: Array<TEpDevPTag>;
  epCustomTags: Array<TEpDevPTag>;
}
export enum EpDevPBooleanString {
  TRUE = "true",
  FALSE = "false"
}
/**
 * Managed Asset base interface.
 * - entity id: the object id and created display name
 */
export interface IEpDevPManagedAsset extends IEpDevPAsset, IEpDevPAssetBrokerTypeInfo {
  applicationDomain?: IEpDevPApplicationDomain; /** not used when creating asset for list */
  customAttributeList: TEpDevPAttributeList;
  attributeList: TEpDevPAttributeList;
  summaryDescription: string | undefined;
  description: string | undefined;
  isSearchable: EpDevPBooleanString;
}
/**
 * Indexable document for a managed asset.
 */
export interface IEpDevPManagedAssetIndexableDocument extends IndexableDocument {
  systemId: string;
  epDevPManagedAsset: IEpDevPManagedAsset;
}
export interface IEpDevPVersionInfo {
  version: string;
  versionId?: string;
  lifecycleState?: string;
}
/**
 * Managed versioned asset.
 */
export interface IEpDevPManagedVersionedAsset extends IEpDevPManagedAsset, IEpDevPAssetLifecycleInfo {
  versionDisplayName: string | undefined;
}
/**
 * Indexable document for a managed versioned asset.
 */
export interface IEpDevPManagedVersionedAssetIndexableDocument extends IEpDevPManagedAssetIndexableDocument {
  epDevPManagedAsset: IEpDevPManagedVersionedAsset;
}
export interface IEpDevPEnvironment4IndexableDocument {
  environmentDisplayNameList: Array<string>;
  environmentIdList: Array<string>;
}
/**
 * Base for asset references
 */
export interface IEpDevPAssetReference extends IEpDevPManagedVersionedAsset {
  isAvailableHere: boolean;
}

/**
 * Application reference.
 */
export interface IEpDevPApplicationReference extends IEpDevPAssetReference {
}
/**
 * Event API reference.
 */
export interface IEpDevPEventApiReference extends IEpDevPAssetReference {
}
/**
 * Event API Product reference.
 */
export interface IEpDevPEventApiProductReference extends IEpDevPAssetReference {
}



